class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/regional-settings`;
    }
    /**
     * Returns information about particular account regional settings
     *
     * HTTP Method: get
     * Endpoint: /restapi/v2/accounts/{accountId}/regional-settings
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     */
    async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Change information about particular account regional settings
     * HTTP Method: patch
     * Endpoint: /restapi/v2/accounts/{accountId}/regional-settings
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     */
    async patch(accountRegionalSettingRequest, restRequestConfig) {
        const r = await this.rc.patch(this.path(), accountRegionalSettingRequest, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
